import React, {FC} from "react"
import styled, {css} from "styled-components"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Label} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

interface Props {
  messageId: string
}

const SearchBarComponent: FC<Props> = ({messageId = "platform.search.searchBar.placeholder"}) => {
  const theme = useTheme()

  return (
    <Wrapper>
      <Flex padding={["8px", "20px"]}>
        <Label color={theme.colors.greys.mediumDark}>
          <FormattedMessage id={messageId} />
        </Label>
      </Flex>
      <IconContainer>
        <Icon id="searchIcon" icon={IconTypes.search} color={theme.colors.greys.white} size={24} />
      </IconContainer>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  ${({theme}) => css`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: ${theme.spacing.two};
    flex: 1;
    gap: 12px;
    background: ${theme.colors.greys.white};
    border-radius: ${theme.border.radius.medium};
    border: 0.5px solid ${theme.colors.greys.mediumLight};
    cursor: pointer;
  `}
`

const IconContainer = styled.div`
  ${({theme}) => css`
    background: ${theme.colors.primary1};
    display: flex;
    padding: 10px;
    border-radius: 0px ${theme.border.radius.medium} ${theme.border.radius.medium} 0px;
    border: 0.5px solid ${theme.colors.primary1};
    height: 100%;
    align-items: center;
  `}
`

export default SearchBarComponent
